import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  ForwardIcon,
  Skeleton,
  Stack,
  Typography,
} from '@all-manager/design-system-v2';
import type { ActivityTimelineFeed } from "../../../../types";
import ActivityTimelineItem from "../ActivityTimeline/ActivityTimelineItem";

type Props = {
  items: ActivityTimelineFeed[];
  isLoading: boolean;
  totalCount: number;
  onSeeMore: () => void;
};

const SKELETON_ROWS = [0, 1];

export default function RecentActivitiesSection(props: Props) {
  const hasMore = props.totalCount > props.items.length;

  return (
    <Card>
      <CardHeader
        title="Dernières activités"
        subheader={props.isLoading ? undefined : `${props.totalCount} activité${props.totalCount > 1 ? 's' : ''} au total`}
      />
      <Divider />

      <CardContent>
        {props.isLoading ? (
          <Stack spacing={1} aria-busy="true" aria-label="Chargement des activités">
            {SKELETON_ROWS.map((row) => (
              <Skeleton key={row} variant="rounded" height={56} />
            ))}
          </Stack>
        ) : props.items.length === 0 ? (
          <Typography variant="noItem">
            Aucune activité pour le moment. Ajoutez un échange, un devis ou un rendez-vous avec « Nouvelle action ».
          </Typography>
        ) : (
          <Stack>
            {props.items.map((item, index) => (
              <ActivityTimelineItem
                key={`${item.entity_type}-${item.id}`}
                item={item}
                isFirst={index === 0}
                isLast={index === props.items.length - 1}
              />
            ))}
          </Stack>
        )}
      </CardContent>

      {hasMore && !props.isLoading ? (
        <CardActions>
          <Button
            variant="text"
            size="small"
            color="default"
            onClick={props.onSeeMore}
            endIcon={<ForwardIcon fontSize="small" />}
          >
            Voir tout l&apos;historique
          </Button>
        </CardActions>
      ) : null}
    </Card>
  );
}
